export default "__VITE_ASSET__CJq4Obou__"